import { Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React from 'react';
import DownloadAppBannerContent from './DownloadAppBannerContent';

const DownloadAppBannerMobile = () => {
  return (
    <Flex
      as={motion.div}
      px={5}
      py={6}
      position="fixed"
      bottom="0"
      zIndex={99}
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      background="black"
      transition="opacity 0.5s ease, padding 0.1s ease"
      initial={{
        opacity: 0
      }}
      animate={{
        opacity: 1
      }}
    >
      <DownloadAppBannerContent />
    </Flex>
  );
};

export default DownloadAppBannerMobile;
